import InputProcessor from './inputProcessor';
import OutputProcessor from './outputProcessor';
import { PRE_RULES as RULES} from '../../config/caf';
import {
  ConversationObj, IntentObj, RawInputObj, ResponseObj, Rule, RuleExecutionContext
} from '../../types/caf';
export class BotProcessor {
    static instance: BotProcessor;

    static conversationId = 0;

    constructor() {
      if (BotProcessor.instance) {
        return BotProcessor.instance;
      }

      BotProcessor.instance = this;

      return this;
    }

    static processIntents(rawInput: RawInputObj): ConversationObj {
      const processedIntent = InputProcessor.getIntents(rawInput.intent);
      const rule = BotProcessor.getRule({ context: rawInput.context, processedIntent: processedIntent });
      const processedRule = BotProcessor.processRule({ context: rawInput.context, rule: rule });
      const outputResponse = OutputProcessor.processResponse({ response: processedRule.response, context: rawInput.context, globalContext: rawInput.globalContext });
      const formattedResponse = BotProcessor.formatResponse(outputResponse);

      return formattedResponse;
    }

    static getRule(inputProcessorResponse: { context: RuleExecutionContext; processedIntent: IntentObj}): Rule {
      const { processedIntent = { intentName: 'something_went_wrong' } } = inputProcessorResponse;
      const rule = RULES[processedIntent.intentName.toLowerCase()];

      return rule;
    }

    static processRule(entityInfo: { context: RuleExecutionContext; rule: Rule}): Rule {
      return entityInfo.rule;
    }

    static getConversationId(): number {
      return ++BotProcessor.conversationId;
    }

    static formatResponse(response: ResponseObj[]): ConversationObj {
      return {
        conversationId: (new Date().getTime() + BotProcessor.getConversationId()).toString(),
        conversation: response
      };
    }
}
